import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from 'ag-grid-enterprise';

@Component({
  selector: 'app-ag-yes-no-status',
  standalone: true,
  templateUrl: './ag-yes-no-status.component.html',
  styleUrl: './ag-yes-no-status.component.scss'
})
export class AgYesNoStatusComponent implements ICellRendererAngularComp {
  @Input() value!: boolean;

  agInit(params: ICellRendererParams): void {
    this.value = params.value;
  }

  refresh(params: ICellRendererParams): boolean {
    this.value = params.value;
    return true;
  }
}
